// extracted by mini-css-extract-plugin
export default {"form":"createCategory_form__Omw-F","formInputBlock":"createCategory_formInputBlock__jkIo1","formInput":"createCategory_formInput__rHnpB"};